import { usePermissions } from '@/hooks/usePermissions';
import { Action, Subject } from '@/lib/permissions';
import * as React from 'react';

interface ProtectedRouteProps {
  action: Action;
  subject: Subject;
  fallback?: React.ReactNode;
}

export const ProtectedRoute: React.FC<
  React.PropsWithChildren<ProtectedRouteProps>
> = ({
  action,
  subject,
  children,
  fallback = (
    <div className='flex items-center justify-center min-h-[400px]'>
      <div className='text-center'>
        <div className='text-6xl mb-4'>🔒</div>
        <h2 className='text-2xl font-semibold text-grey-900  mb-2'>
          Access Denied
        </h2>
        <p className='text-grey-600'>
          You don&apos;t have permission to access this resource.
        </p>
      </div>
    </div>
  ),
}) => {
  const { can } = usePermissions();

  if (!can(action, subject)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
